import axios from "axios";
import * as employeeDesignationTypes from "../../types/admin/employeeDesignationTypes";

export const getAllEmployeeDesignationAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: employeeDesignationTypes.GET_ALL_EMPLOYEE_DESIGNATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/designations/get-all`,
        config
      );

      dispatch({
        type: employeeDesignationTypes.GET_ALL_EMPLOYEE_DESIGNATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: employeeDesignationTypes.GET_ALL_EMPLOYEE_DESIGNATION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const createEmployeeDesignationAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employeeDesignationTypes.CREATE_EMPLOYEE_DESIGNATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employee-designations/create`,
        formData,
        config
      );

      dispatch({
        type: employeeDesignationTypes.CREATE_EMPLOYEE_DESIGNATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: employeeDesignationTypes.CREATE_EMPLOYEE_DESIGNATION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateEmployeeDesignationAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employeeDesignationTypes.UPDATE_EMPLOYEE_DESIGNATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employee-designations/update`,
        formData,
        config
      );

      dispatch({
        type: employeeDesignationTypes.UPDATE_EMPLOYEE_DESIGNATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: employeeDesignationTypes.UPDATE_EMPLOYEE_DESIGNATION_FAIL,
        payload: err,
      });
      throw err;
    }
  };
export const deleteEmployeeDesignationAction =
  (oldDesignationId, newDesignationId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employeeDesignationTypes.DELETE_EMPLOYEE_DESIGNATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const payload = { oldDesignationId };
      if (newDesignationId) {
        payload.newDesignationId = newDesignationId; // Add only if present
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employee-designations/delete`,
        {
          ...config,
          data: payload,
        }
      );

      dispatch({
        type: employeeDesignationTypes.DELETE_EMPLOYEE_DESIGNATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: employeeDesignationTypes.DELETE_EMPLOYEE_DESIGNATION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const bulkAssignEmployeeDesignationAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employeeDesignationTypes.BULK_ASSIGN_EMPLOYEE_DESIGNATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employee-designations/bulk-assign`,
        formData,
        config
      );

      dispatch({
        type: employeeDesignationTypes.BULK_ASSIGN_EMPLOYEE_DESIGNATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: employeeDesignationTypes.BULK_ASSIGN_EMPLOYEE_DESIGNATION_FAIL,
        payload: err,
      });
      throw err;
    }
  };
